import { Tooltip, Typography } from '@doc/ui-components';
import { usePathname } from 'next/navigation';
import { useAtomValue } from 'jotai';
import { projectAtom } from '@/shared/project/utils/project.util';

export const HeaderProjectName = () => {
	const pathname = usePathname();
	const { projectName } = useAtomValue(projectAtom);

	if ((!pathname.includes('selectivity') && !pathname.includes('backup')) || !projectName) return null;

	return (
		<Tooltip content={projectName} placement='bottom'>
			<Typography className='min-w-0 truncate max-w-125' weight='font-semibold' size='text-xl'>
				{projectName}
			</Typography>
		</Tooltip>
	);
};
